module.exports = __webpack_public_path__ + "static/media/8.b3aa114d.jpg";